import { render } from "./App.vue?vue&type=template&id=d59bca6c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d59bca6c&lang=css"

import exportComponent from "E:\\Project Repository\\11-Isomat\\code\\services\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__